if (new URLSearchParams(window.location.search).get('webview') === 'true') {
  document.body.classList.add('mobileapp-webview');
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

class SectionId {
  static #separator = '__';

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}


function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();

    document.addEventListener('click', this.onDocumentClick.bind(this));
  }

  // bindEvents() {
  //   this.querySelectorAll('summary').forEach((summary) =>
  //     summary.addEventListener('click', this.onSummaryClick.bind(this))
  //   );
  //   this.querySelectorAll(
  //     'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
  //   ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  // }
  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) => {
      // Standard click listener
      summary.addEventListener('click', this.onSummaryClick.bind(this));

      // Desktop Hover Listener
      summary.addEventListener('mouseenter', (event) => {
        if (window.matchMedia('(min-width: 990px)').matches) {
          const summaryElement = event.currentTarget;
          const detailsElement = summaryElement.parentNode;

          if (detailsElement === this.mainDetailsToggle) return;

          // Open all levels on hover
          // if (detailsElement.closest('.menu-drawer__submenu')) return;

          // Close sibling submenus in the same column
          const parentUl = detailsElement.closest('ul');
          if (parentUl) {
            const openSiblings = parentUl.querySelectorAll(':scope > li > details[open]');
            openSiblings.forEach((sibling) => {
              if (sibling !== detailsElement) {
                sibling.removeAttribute('open');
                sibling.classList.remove('menu-opening');
                sibling.querySelector('summary')?.setAttribute('aria-expanded', 'false');

                // Recursively close all nested open submenus inside siblings
                sibling.querySelectorAll('details[open]').forEach((nested) => {
                  nested.removeAttribute('open');
                  nested.classList.remove('menu-opening');
                  nested.querySelector('summary')?.setAttribute('aria-expanded', 'false');
                });
              }
            });
          }

          // If already open, close all nested submenus inside it on hover (e.g. hovering back to first level summary)
          if (detailsElement.hasAttribute('open')) {
            detailsElement.querySelectorAll('details[open]').forEach((nested) => {
              nested.removeAttribute('open');
              nested.classList.remove('menu-opening');
              nested.querySelector('summary')?.setAttribute('aria-expanded', 'false');
            });
          }

          // Open target submenu
          if (!detailsElement.hasAttribute('open')) {
            detailsElement.setAttribute('open', '');
            detailsElement.classList.add('menu-opening');
            summaryElement.setAttribute('aria-expanded', 'true');
          }
        }
      });
    });

    // Close sibling submenus when hovering over a menu item with no submenu on desktop
    this.querySelectorAll('.menu-drawer__navigation li > a').forEach((link) => {
      link.addEventListener('mouseenter', (event) => {
        if (window.matchMedia('(min-width: 990px)').matches) {
          const parentUl = link.closest('ul');
          if (parentUl) {
            const openSiblings = parentUl.querySelectorAll(':scope > li > details[open]');
            openSiblings.forEach((sibling) => {
              sibling.removeAttribute('open');
              sibling.classList.remove('menu-opening');
              sibling.querySelector('summary')?.setAttribute('aria-expanded', 'false');

              // Recursively close all nested open submenus
              sibling.querySelectorAll('details[open]').forEach((nested) => {
                nested.removeAttribute('open');
                nested.classList.remove('menu-opening');
                nested.querySelector('summary')?.setAttribute('aria-expanded', 'false');
              });
            });
          }
        }
      });
    });

    // Collapse submenus when the mouse leaves the drawer on desktop
    const menuDrawerEl = this.querySelector('.menu-drawer');
    if (menuDrawerEl) {
      menuDrawerEl.addEventListener('mouseleave', () => {
        if (window.matchMedia('(min-width: 990px)').matches) {
          this.querySelectorAll('.menu-drawer__navigation > .menu-drawer__menu > li > details[open]').forEach((sibling) => {
            sibling.removeAttribute('open');
            sibling.classList.remove('menu-opening');
            sibling.querySelector('summary')?.setAttribute('aria-expanded', 'false');

            // Recursively close all nested open submenus
            sibling.querySelectorAll('details[open]').forEach((nested) => {
              nested.removeAttribute('open');
              nested.classList.remove('menu-opening');
              nested.querySelector('summary')?.setAttribute('aria-expanded', 'false');
            });
          });
        }
      });
    }

    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onDocumentClick(event) {
    if (window.matchMedia('(max-width: 989px)').matches) return;
    if (!this.mainDetailsToggle.hasAttribute('open')) return;

    const menuDrawerEl = this.querySelector('.menu-drawer');
    const summaryEl = this.querySelector('summary');
    if (menuDrawerEl && summaryEl) {
      if (!menuDrawerEl.contains(event.target) && !summaryEl.contains(event.target)) {
        this.closeMenuDrawer(event, summaryEl);
        return;
      }
    }

    const openSubmenus = this.querySelectorAll('ul > li > details[open]');
    openSubmenus.forEach((details) => {
      // Close the submenu if the click is outside of it
      if (!details.contains(event.target)) {
        this.closeSubmenu(details);
      }
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)').matches) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      if (window.matchMedia('(max-width: 989px)').matches) {
        // Mobile accordion logic:
        // Let the default details toggle open/close. We just toggle aria-expanded and classes.
        if (isOpen) {
          detailsElement.classList.remove('menu-opening');
          summaryElement.setAttribute('aria-expanded', 'false');
        } else {
          detailsElement.classList.add('menu-opening');
          summaryElement.setAttribute('aria-expanded', 'true');
        }
        return;
      }

      if (window.matchMedia('(min-width: 990px)').matches) {
        event.preventDefault();
        return;
      }

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

// class HeaderDrawer extends MenuDrawer {
//   constructor() {
//     super();
//   }

//   // openMenuDrawer(summaryElement) {
//   //   this.header = this.header || document.querySelector('.section-header');
//   //   this.borderOffset =
//   //     this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
//   //   document.documentElement.style.setProperty(
//   //     '--header-bottom-position',
//   //     `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
//   //   );
//   //   this.header.classList.add('menu-open');

//   //   setTimeout(() => {
//   //     this.mainDetailsToggle.classList.add('menu-opening');
//   //   });

//   //   summaryElement.setAttribute('aria-expanded', true);
//   //   window.addEventListener('resize', this.onResize);
//   //   trapFocus(this.mainDetailsToggle, summaryElement);
//   //   document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
//   // }
//   openMenuDrawer(summaryElement) {
//     this.header = this.header || document.querySelector('.section-header');

//     this.borderOffset =
//       this.borderOffset ||
//       (this.closest('.header-wrapper').classList.contains(
//         'header-wrapper--border-bottom'
//       )
//         ? 1
//         : 0);

//     document.documentElement.style.setProperty(
//       '--header-bottom-position',
//       `${parseInt(
//         this.header.getBoundingClientRect().bottom - this.borderOffset,
//         10
//       )}px`
//     );

//     this.header.classList.add('menu-open');

//     /*
//     * Desktop-only state.
//     * Mobile/tablet keeps Dawn's existing behavior.
//     */
//     if (window.innerWidth >= 990) {
//       document.body.classList.add('menu-drawer-desktop-open');
//     }

//     /*
//     * Give the browser a render opportunity before
//     * adding menu-opening so the CSS transform animates.
//     */
//     requestAnimationFrame(() => {
//       this.mainDetailsToggle.classList.add('menu-opening');
//     });

//     summaryElement.setAttribute('aria-expanded', true);

//     window.addEventListener('resize', this.onResize);

//     trapFocus(this.mainDetailsToggle, summaryElement);

//     document.body.classList.add(
//       `overflow-hidden-${this.dataset.breakpoint}`
//     );
// }

//   // closeMenuDrawer(event, elementToFocus) {
//   //   if (!elementToFocus) return;
//   //   super.closeMenuDrawer(event, elementToFocus);
//   //   this.header.classList.remove('menu-open');
//   //   window.removeEventListener('resize', this.onResize);
//   // }
//   closeMenuDrawer(event, elementToFocus) {
//   if (!elementToFocus) return;

//   if (window.innerWidth >= 990) {
//     document.body.classList.remove('menu-drawer-desktop-open');
//   }

//   super.closeMenuDrawer(event, elementToFocus);

//   this.header.classList.remove('menu-open');

//   window.removeEventListener('resize', this.onResize);
// }

//   onResize = () => {
//     this.header &&
//       document.documentElement.style.setProperty(
//         '--header-bottom-position',
//         `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
//       );
//     document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
//   };
// }
class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');

    this.borderOffset =
      this.borderOffset ||
      (this.closest('.header-wrapper').classList.contains(
        'header-wrapper--border-bottom'
      )
        ? 1
        : 0);

    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${Math.round(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    document.documentElement.style.setProperty(
      '--header-top-position',
      `${Math.round(this.header.getBoundingClientRect().top)}px`
    );

    this.header.classList.add('menu-open');

    /*
     * Desktop only.
     * Mobile remains Dawn's native implementation.
     */
    if (window.matchMedia('(min-width: 990px)').matches) {
      document.body.classList.add('menu-drawer-desktop-open');
    }

    /*
     * Allow the browser to render the closed state first,
     * then trigger the opening transition.
     */
    requestAnimationFrame(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', 'true');

    window.addEventListener('resize', this.onResize);

    trapFocus(this.mainDetailsToggle, summaryElement);

    document.body.classList.add(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;

    if (window.matchMedia('(min-width: 990px)').matches) {
      document.body.classList.remove('menu-drawer-desktop-open');
    }

    super.closeMenuDrawer(event, elementToFocus);

    this.header.classList.remove('menu-open');

    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    if (!this.header) return;

    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${Math.round(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );

    document.documentElement.style.setProperty(
      '--viewport-height',
      `${window.innerHeight}px`
    );
  };
}

// customElements.define('header-drawer', HeaderDrawer);

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (
          event.pointerType === 'mouse' &&
          !event.target.closest(
            'deferred-media, product-model, .product-media-modal__nav, .product-media-modal__toggle, img'
          )
        )
          this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    this.dataset.section = this.closest('.shopify-section').id.replace('shopify-section-', '');
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class BulkModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (this.innerHTML.trim() === '') {
        const productUrl = this.dataset.url.split('?')[0];
        fetch(`${productUrl}?section_id=bulk-quick-order-list`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector('.quick-order-list-container').parentNode;
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    };

    new IntersectionObserver(handleIntersection.bind(this)).observe(
      document.querySelector(`#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`)
    );
  }
}

customElements.define('bulk-modal', BulkModal);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }

      // Workaround for safari iframe bug
      const formerStyle = deferredElement.getAttribute('style');
      deferredElement.setAttribute('style', 'display: block;');
      window.setTimeout(() => {
        deferredElement.setAttribute('style', formerStyle);
      }, 0);
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  // Which slide is aligned to the inline-start edge. scrollLeft's sign differs
  // across RTL browsers, so the visible slide is the reliable page index.
  getRtlAlignedPage() {
    const slides = this.sliderItemsToShow;
    if (!slides || !slides.length || !this.slider) return 0;

    const sliderRight = this.slider.getBoundingClientRect().right;
    let closestIndex = 0;
    let closestDistance = Infinity;

    slides.forEach((slide, index) => {
      const distance = Math.abs(slide.getBoundingClientRect().right - sliderRight);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    return closestIndex + 1;
  }

  // scrollLeft change needed to move a slide 1px to the right.
  // Chrome RTL is -1; Firefox RTL is +1. Measured on this slider so a dot
  // click does not assume one browser's scrollLeft sign.
  getRtlContentScrollRatio(slider) {
    if (this._rtlContentScrollRatio) return this._rtlContentScrollRatio;

    const slide = this.sliderItemsToShow && this.sliderItemsToShow[0];
    if (!slider || !slide) return -1;

    const previousBehavior = slider.style.scrollBehavior;
    const previousSnap = slider.style.scrollSnapType;
    slider.style.scrollBehavior = 'auto';
    slider.style.scrollSnapType = 'none';
    this._suppressSlideUpdate = true;

    const startScroll = slider.scrollLeft;
    const startRight = slide.getBoundingClientRect().right;
    const measureShift = (sample) => {
      slider.scrollLeft = startScroll + sample;
      const shift = slide.getBoundingClientRect().right - startRight;
      slider.scrollLeft = startScroll;
      return shift;
    };

    let sample = -10;
    let shift = measureShift(sample);
    if (Math.abs(shift) < 0.5) {
      sample = 10;
      shift = measureShift(sample);
    }

    this._suppressSlideUpdate = false;
    slider.style.scrollSnapType = previousSnap;
    slider.style.scrollBehavior = previousBehavior;

    this._rtlContentScrollRatio = Math.abs(shift) < 0.5 ? -1 : sample / shift;
    return this._rtlContentScrollRatio;
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (this._suppressSlideUpdate) return;
    if (!this.slider || !this.nextButton || !this.sliderItemsToShow || !this.sliderItemsToShow.length) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (
      this.classList.contains('homepage-slideshow') &&
      getComputedStyle(this.slider).direction === 'rtl'
    ) {
      const visualPage = this.getRtlAlignedPage();
      if (visualPage) this.currentPage = visualPage;
    }

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    if (!element) return false;
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  // setAutoPlay() {
  //   this.autoplaySpeed = this.slider.dataset.speed * 1000;
  //   this.addEventListener('mouseover', this.focusInHandling.bind(this));
  //   this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
  //   this.addEventListener('focusin', this.focusInHandling.bind(this));
  //   this.addEventListener('focusout', this.focusOutHandling.bind(this));

  //   if (this.querySelector('.slideshow__autoplay')) {
  //     this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
  //     this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
  //     this.autoplayButtonIsSetToPlay = true;
  //     this.play();
  //   } else {
  //     this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
  //   }
  // }
  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');

    if (!this.sliderAutoplayButton) return;

    this.autoplaySpeed = Number(this.slider.dataset.speed) * 1000;

    /*
     * Respect the user's reduced-motion preference.
     * This is evaluated safely at runtime and does not
     * depend on an uninitialized class property.
     */
    this.prefersReducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    );

    this.sliderAutoplayButton.addEventListener(
      'click',
      this.autoPlayToggle.bind(this)
    );

    this.addEventListener(
      'mouseover',
      this.focusInHandling.bind(this)
    );

    this.addEventListener(
      'mouseleave',
      this.focusOutHandling.bind(this)
    );

    this.addEventListener(
      'focusin',
      this.focusInHandling.bind(this)
    );

    this.addEventListener(
      'focusout',
      this.focusOutHandling.bind(this)
    );

    /*
     * Don't automatically start slideshow when the user
     * has requested reduced motion.
     */
    if (this.prefersReducedMotion.matches) {
      this.autoplayButtonIsSetToPlay = false;
      this.pause();
      this.togglePlayButtonState(true);
      return;
    }

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    const activeLink = this.sliderControlButtons[this.currentPage - 1];
    if (!activeLink) return;
    activeLink.classList.add('slider-counter__link--active');
    activeLink.setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  // play() {
  //   this.slider.setAttribute('aria-live', 'off');
  //   clearInterval(this.autoplay);
  //   this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  // }
  play() {
    if (!this.slider || !this.autoplaySpeed) return;

    this.slider.setAttribute('aria-live', 'off');

    clearInterval(this.autoplay);

    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  // pause() {
  //   this.slider.setAttribute('aria-live', 'polite');
  //   clearInterval(this.autoplay);
  // }
  pause() {
    if (!this.slider) return;

    this.slider.setAttribute('aria-live', 'polite');

    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const index = this.sliderControlLinksArray.indexOf(event.currentTarget);

    if (
      index > -1 &&
      this.classList.contains('homepage-slideshow') &&
      this.slider &&
      getComputedStyle(this.slider).direction === 'rtl'
    ) {
      const slide = this.sliderItemsToShow && this.sliderItemsToShow[index];
      if (!slide) return;

      const ratio = this.getRtlContentScrollRatio(this.slider);
      const neededMove = this.slider.getBoundingClientRect().right - slide.getBoundingClientRect().right;
      this.scrollHomepageSlide(Math.round(this.slider.scrollLeft + neededMove * ratio));
      return;
    }

    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth * (index + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  // Assign scrollLeft directly. Chrome drops negative scrollTo() targets while
  // scroll-behavior is smooth, which is how RTL overflow is represented.
  scrollHomepageSlide(left) {
    const slider = this.slider;
    if (!slider) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const token = (this._rtlScrollToken || 0) + 1;
    this._rtlScrollToken = token;

    if (!this._rtlScrollAnimating) {
      this._rtlPrevBehavior = slider.style.scrollBehavior;
      this._rtlPrevSnap = slider.style.scrollSnapType;
    }
    this._rtlScrollAnimating = true;
    slider.style.scrollBehavior = 'auto';

    const start = slider.scrollLeft;
    const distance = left - start;
    if (reducedMotion || Math.abs(distance) < 1) {
      slider.scrollLeft = left;
      this.finishHomepageSlideScroll(token);
      return;
    }

    slider.style.scrollSnapType = 'none';
    const duration = 450;
    const startedAt = performance.now();
    const step = (now) => {
      if (token !== this._rtlScrollToken) return;
      const progress = Math.min(1, (now - startedAt) / duration);
      const eased = 1 - Math.pow(1 - progress, 3);
      slider.scrollLeft = start + distance * eased;
      if (progress < 1) {
        requestAnimationFrame(step);
        return;
      }
      slider.scrollLeft = left;
      this.finishHomepageSlideScroll(token);
    };
    requestAnimationFrame(step);
  }

  finishHomepageSlideScroll(token) {
    if (token !== this._rtlScrollToken || !this.slider) return;
    this.slider.style.scrollBehavior = this._rtlPrevBehavior || '';
    this.slider.style.scrollSnapType = this._rtlPrevSnap || '';
    this._rtlScrollAnimating = false;
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      this.dispatchProductSelectEvent();

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  getAllSelectedOptions() {
    const options = [];
    this.querySelectorAll('fieldset, .product-form__input--dropdown').forEach((group) => {
      const checked = group.querySelector('input:checked') || group.querySelector('select option[selected]');
      if (checked) {
        options.push({ name: checked.dataset.optionName || '', value: checked.value });
      }
    });
    return options;
  }

  dispatchProductSelectEvent() {
    const { ProductSelectEvent } = window.StandardEvents || {};
    if (!ProductSelectEvent) return;

    const deferred = ProductSelectEvent.createPromise();
    this.pendingSelectPromise = deferred;

    this.dispatchEvent(
      new ProductSelectEvent({
        product: {
          id: this.dataset.productId,
          title: this.dataset.productTitle,
          handle: this.dataset.productHandle,
        },
        selectedOptions: this.getAllSelectedOptions(),
        promise: deferred.promise,
      })
    );
  }

  takePendingSelectPromise() {
    const deferred = this.pendingSelectPromise;
    this.pendingSelectPromise = null;
    return deferred;
  }

  resolvePendingSelectPromise(variant, sourceVariantSelects = this) {
    const deferred = this.takePendingSelectPromise();
    if (!deferred) return;

    if (variant) {
      deferred.resolve({
        variant: {
          id: variant.id,
          title: variant.title,
          availableForSale: variant.available,
          price: {
            amount: sourceVariantSelects?.dataset.selectedPriceAmount,
            currencyCode: sourceVariantSelects?.dataset.currencyCode,
          },
          selectedOptions: this.getAllSelectedOptions(),
        },
      });
    } else {
      deferred.resolve({ variant: null });
    }
  }

  rejectPendingSelectPromise(error) {
    this.takePendingSelectPromise()?.reject(error);
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute('selected'))
        .removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');

      // "Option name: selected value" text in the <label> (distinct from the
      // dropdown-swatch preview's own [data-selected-value] below, which
      // only ever holds the swatch visual, not text).
      const selectedValueLabel = target.closest('.product-form__input')?.querySelector('label [data-selected-value]');
      if (selectedValueLabel) selectedValueLabel.innerHTML = value;

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        .querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }

        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

class BulkAdd extends HTMLElement {
  static ASYNC_REQUEST_DELAY = 250;

  constructor() {
    super();
    this.queue = [];
    this.setRequestStarted(false);
    this.ids = [];
  }

  startQueue(id, quantity) {
    this.queue.push({ id, quantity });

    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue);
        }
      } else {
        clearInterval(interval);
      }
    }, BulkAdd.ASYNC_REQUEST_DELAY);
  }

  sendRequest(queue) {
    this.setRequestStarted(true);
    const items = {};

    queue.forEach((queueItem) => {
      items[parseInt(queueItem.id)] = queueItem.quantity;
    });
    this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));

    this.updateMultipleQty(items);
  }

  setRequestStarted(requestStarted) {
    this._requestStarted = requestStarted;
  }

  get requestStarted() {
    return this._requestStarted;
  }

  getCartQuantityForLine(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    return parseInt(input?.dataset.cartQuantity || input?.getAttribute('value') || '0', 10) || 0;
  }

  startCartLinesUpdate(items) {
    const { CartLinesUpdateEvent } = window.StandardEvents || {};
    if (!CartLinesUpdateEvent) return;

    const linesByAction = Object.entries(items).reduce((groups, [variantId, quantity]) => {
      const nextQuantity = parseInt(quantity, 10);
      const currentQuantity = this.getCartQuantityForLine(variantId);

      if (Number.isNaN(nextQuantity) || currentQuantity === nextQuantity) return groups;

      const action = currentQuantity === 0 ? 'add' : nextQuantity === 0 ? 'remove' : 'update';
      let line;
      if (action === 'add') {
        line = { merchandiseId: variantId, quantity: nextQuantity };
      } else {
        const lineKey = this.querySelector(`[data-quantity-variant-id="${variantId}"]`)?.dataset.quantityLineKey;
        // No AJAX line key on the row — likely cached HTML rendered before this
        // attribute landed. Skip rather than emit an event with id: ''.
        if (!lineKey) return groups;
        line = { id: lineKey, quantity: nextQuantity };
      }

      if (!groups[action]) groups[action] = [];
      groups[action].push(line);
      return groups;
    }, {});

    const deferreds = Object.entries(linesByAction).map(([action, lines]) => {
      const deferred = CartLinesUpdateEvent.createPromise();
      this.dispatchEvent(
        new CartLinesUpdateEvent({
          action,
          context: 'product',
          lines,
          promise: deferred.promise,
        })
      );
      return deferred;
    });

    return {
      resolve: (parsedState) => {
        const payload = { cart: CartLinesUpdateEvent.createCartFromAjaxResponse(parsedState) };
        deferreds.forEach((deferred) => deferred.resolve(payload));
      },
      reject: (error) => {
        deferreds.forEach((deferred) => deferred.reject(error));
      },
    };
  }

  dispatchCartErrorEvent(message, code) {
    const { CartErrorEvent } = window.StandardEvents || {};
    if (!CartErrorEvent) return;

    this.dispatchEvent(new CartErrorEvent({ error: message, code }));
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;

    if (inputValue < event.target.dataset.min) {
      this.setValidity(event, index, window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min));
    } else if (inputValue > parseInt(event.target.max)) {
      this.setValidity(event, index, window.quickOrderListStrings.max_error.replace('[max]', event.target.max));
    } else if (inputValue % parseInt(event.target.step) != 0) {
      this.setValidity(event, index, window.quickOrderListStrings.step_error.replace('[step]', event.target.step));
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      event.target.setAttribute('value', inputValue);
      this.startQueue(index, inputValue);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

if (!customElements.get('bulk-add')) {
  customElements.define('bulk-add', BulkAdd);
}

class CartPerformance {
  static #metric_prefix = "cart-performance"

  static createStartingMarker(benchmarkName) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    return performance.mark(`${metricName}:start`);
  }

  static measureFromEvent(benchmarkName, event) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`, {
      startTime: event.timeStamp
    });

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      metricName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }

  static measureFromMarker(benchmarkName, startMarker) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      metricName,
      startMarker.name,
      `${metricName}:end`
    );
  }

  static measure(benchmarkName, callback) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`);

    callback();

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      metricName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }
}

class PasswordShowToggle {
  static #boundAttribute = 'data-password-show-bound';
  static #selector = [
    'input[data-cf-column-key="password"]',
    'input[name="password"]',
    'input[data-cf-column-key="current_password"]',
    'input[name="current_password"]',
    'input[data-cf-field-type="password"]',
    'input[name="customer[password]"]',
  ].join(', ');

  static init() {
    if (!this.#isRegisterPage()) return;

    this.enhance();

    const observer = new MutationObserver(() => this.enhance());
    observer.observe(document.body, { childList: true, subtree: true });
  }

  static #isRegisterPage() {
    return (
      document.body.classList.contains('template-customers-register') ||
      window.location.pathname.includes('/account/register')
    );
  }

  static enhance() {
    document.querySelectorAll(this.#selector).forEach((input) => this.#attach(input));
  }

  static #attach(input) {
    if (!(input instanceof HTMLInputElement)) return;
    if (input.hasAttribute(this.#boundAttribute)) return;

    const existingToggle = this.#findExistingToggle(input);
    const toggle = existingToggle || this.#createToggle();

    if (!existingToggle) {
      input.insertAdjacentElement('afterend', toggle);
    }

    this.#positionToggle(toggle, input);
    this.#bindToggle(toggle, input);
    input.setAttribute(this.#boundAttribute, 'true');
  }

  static #positionToggle(toggle, input) {
    const parent = input.parentElement;
    if (!parent) return;

    if (getComputedStyle(parent).position === 'static') {
      parent.style.position = 'relative';
    }

    toggle.style.top = `${input.offsetTop}px`;
    toggle.style.height = `${input.offsetHeight}px`;
  }

  static #findExistingToggle(input) {
    const nextSibling = input.nextElementSibling;
    if (nextSibling?.classList.contains('password-show')) return nextSibling;

    return input.parentElement?.querySelector(':scope > .password-show') || null;
  }

  static #createToggle() {
    const toggle = document.createElement('span');
    toggle.className = 'password-show';
    toggle.setAttribute('role', 'button');
    toggle.setAttribute('tabindex', '0');
    toggle.setAttribute('aria-label', 'Show password');
    return toggle;
  }

  static #bindToggle(toggle, input) {
    const syncState = () => {
      const isVisible = input.type === 'text';
      toggle.classList.toggle('is-visible', isVisible);
      toggle.setAttribute('aria-label', isVisible ? 'Hide password' : 'Show password');
    };

    const toggleVisibility = (event) => {
      event.preventDefault();
      input.type = input.type === 'password' ? 'text' : 'password';
      syncState();
    };

    toggle.addEventListener('click', toggleVisibility);
    toggle.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        toggleVisibility(event);
      }
    });

    syncState();
  }
}

PasswordShowToggle.init();

(function () {
  let initialized = false;

  function initializeChannels() {
    if (initialized) return;

    const field = document.querySelector(
      '.custom-channel-selected'
    );

    if (!field) return false;

    const checkboxes = field.querySelectorAll(
      'input[data-cf-input][type="checkbox"]'
    );

    if (!checkboxes.length) return false;

    initialized = true;

    checkboxes.forEach(function (checkbox) {
      if (!checkbox.checked) {
        checkbox.click();
      }
    });

    return true;
  }

  // Try immediately
  initializeChannels();

  // Wait for Forms app to create the field
  const observer = new MutationObserver(function () {
    if (initializeChannels()) {
      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();

// Bloomreach products section
// Cards use a lightweight section render; wishlist state syncs via Wishlister.refresh.
const bloomreachProductJsonCache = new Map();
const bloomreachCardRequestCache = new Map();
const BLOOMREACH_CARD_SECTION = 'bloomreach-product-cards';
const BLOOMREACH_HEART_OUTLINE = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style="height:20px;" fill="currentColor"><path d="M458.4 64.3C400.6 15.7 311.3 23 256 79.3 200.7 23 111.4 15.6 53.6 64.3-21.6 127.6-10.6 230.8 43 285.5l175.4 178.7c10 10.2 23.4 15.9 37.6 15.9 14.3 0 27.6-5.6 37.6-15.8L469 285.6c53.5-54.7 64.7-157.9-10.6-221.3zm-23.6 187.5L259.4 430.5c-2.4 2.4-4.4 2.4-6.8 0L77.2 251.8c-36.5-37.2-43.9-107.6 7.3-150.7 38.9-32.7 98.9-27.8 136.5 10.5l35 35.7 35-35.7c37.8-38.5 97.8-43.2 136.5-10.6 51.1 43.1 43.5 113.9 7.3 150.8z"></path></svg>';
const BLOOMREACH_HEART_FILLED = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style="height:20px;" fill="currentColor"><path d="M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"></path></svg>';

let bloomreachWishlistStatePromise = null;

function bloomreachWishlistIdentity() {
  const readCookie = (name) => {
    const parts = ('; ' + document.cookie).split('; ' + name + '=');
    if (parts.length < 2) return '';
    return parts.pop().split(';').shift() || '';
  };
  const customer = readCookie('ms_customer_id');
  if (customer && customer !== '0' && customer !== 'undefined' && customer !== 'null') {
    return { productcustomerId: customer, unique_device_id: readCookie('new_unique_device_id') || '' };
  }
  let device = readCookie('new_unique_device_id');
  if (!device) {
    device = `${Math.random().toString(36).slice(2, 11)}-web`;
    document.cookie = `new_unique_device_id=${device}; path=/; max-age=${3600 * 24 * 30}`;
  }
  const field = document.getElementById('ms_customer_id');
  const fieldValue = (field && field.value) || '';
  return {
    productcustomerId: fieldValue && fieldValue !== '0' ? fieldValue : '',
    unique_device_id: device
  };
}

function prefetchBloomreachWishlistState() {
  if (window.__bloomreachWishlistState) return Promise.resolve(window.__bloomreachWishlistState);
  if (bloomreachWishlistStatePromise) return bloomreachWishlistStatePromise;

  const shop = window.Shopify && window.Shopify.shop;
  if (!shop) return Promise.resolve(null);

  const identity = bloomreachWishlistIdentity();
  bloomreachWishlistStatePromise = fetch('https://wishlistapp.binaryic.in/getWishlistIconState', {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json' },
    body: new URLSearchParams({
      productcustomerId: identity.productcustomerId || '',
      store_name: shop,
      unique_device_id: identity.unique_device_id || ''
    })
  })
    .then((response) => (response.ok ? response.json() : null))
    .then((data) => {
      if (!data || data.error || !data.icondata) return null;
      const wishlisted = {};
      (data.wishlisted_variant_ids || []).forEach((id) => {
        wishlisted[String(id)] = true;
      });
      const state = {
        icondata: data.icondata,
        wishlisted,
        count: data.addwishdataCount
      };
      window.__bloomreachWishlistState = state;
      return state;
    })
    .catch(() => null);

  return bloomreachWishlistStatePromise;
}

function applyBloomreachWishlistState(root, state) {
  if (!root || !state) return;
  const wishlisted = state.wishlisted || {};
  const colors = state.icondata || {};
  root.querySelectorAll('#mswishlistbutton, .mswishlistbutton, [id^="mswishlistbutton"]').forEach((btn) => {
    if (btn.getAttribute('data-wl-pending') === '1') return;
    const variantId = btn.getAttribute('data-variant');
    const productId = btn.getAttribute('data-product');
    if (!variantId || !productId) return;
    const active = wishlisted[String(variantId)] === true;
    btn.setAttribute('data-wl-active', active ? '1' : '0');
    let wishDiv = btn.querySelector('.wishlistDiv');
    if (!wishDiv) {
      wishDiv = document.createElement('div');
      wishDiv.className = 'wishlistDiv';
      wishDiv.style.cssText = 'display:flex;align-items:center;';
      btn.appendChild(wishDiv);
    }
    wishDiv.innerHTML = active ? BLOOMREACH_HEART_FILLED : BLOOMREACH_HEART_OUTLINE;
    const color = active ? colors.wishlist_icon_hover_color : colors.wishlist_icon_color;
    if (color) wishDiv.style.color = color;
  });
}

function syncBloomreachWishlist(root) {
  prefetchBloomreachWishlistState().then((state) => {
    if (state) applyBloomreachWishlistState(root, state);
  });
  if (window.Wishlister && typeof window.Wishlister.refresh === 'function') {
    window.Wishlister.refresh();
    return;
  }
  if (typeof window.reloadThirdPartyWishlistApp === 'function') {
    window.reloadThirdPartyWishlistApp({ immediate: true });
  }
}

function parseBloomreachCardHtml(html) {
  if (!html) return null;
  const parsed = new DOMParser().parseFromString(html, 'text/html');
  const list = parsed.querySelector('[data-bloomreach-card-list]');
  if (list) {
    return list.querySelector('li[data-bloomreach-product], li[data-search-product-card], li[data-product-id]');
  }
  return parsed.querySelector('li[data-search-product-card]')
    || parsed.querySelector('li[data-bloomreach-product]')
    || parsed.querySelector('li[data-product-id]');
}

class BloomreachRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;
    this.enableMouseScroll();
    this.bindReliableArrowScroll();
    prefetchBloomreachWishlistState();

    this.campaignId = this.dataset.campaignId;
    this.limit = Number(this.dataset.limit || 10);
    this.fillWithRandom = this.dataset.fillRandom === 'true';
    this.strategy = this.dataset.strategy;
    this.sectionId = this.dataset.sectionId;
    this.context = this.dataset.context;
    this.variantId = this.dataset.variantId;
    this.productId = this.dataset.productId;

    if (!this.campaignId || !this.sectionId) return;

    if (this.dataset.slidesDesktop) {
      window.addEventListener('resize', () => {
        const count = this.querySelectorAll('li[id^="Slide-"]').length;
        if (count) this.toggleArrows(count);
      });
    }

    const enqueue = () => {
      this.requestRecommendations();
    };

    if (!this.dataset.cardSection || (window.exponea && typeof window.exponea.getRecommendation === 'function')) {
      enqueue();
      return;
    }

    const started = Date.now();
    const waitForSdk = () => {
      if (window.exponea && typeof window.exponea.getRecommendation === 'function') {
        enqueue();
        return;
      }
      if (Date.now() - started > 15000) {
        this.hideSection();
        return;
      }
      setTimeout(waitForSdk, 100);
    };
    waitForSdk();
  }

  requestRecommendations() {
    const campaignId = this.campaignId;
    const sectionId = this.sectionId;

    return new Promise((resolve) => {
      let settled = false;
      const finish = () => {
        if (settled) return;
        settled = true;
        resolve();
      };
      const timer = setTimeout(() => {
        if (this.dataset.cardSection && !this.querySelector('li[id^="Slide-"]')) this.hideSection();
        this.dismissLoading();
        finish();
      }, 15000);

      const options = {
        recommendationId: campaignId,
        size: this.limit,
        fillWithRandom: this.fillWithRandom,
        strategy: this.strategy,
        noTrack: true,
        callback: (data) => {
          if (settled) return;
          clearTimeout(timer);
          finish();
          const renderTimer = setTimeout(() => {
            this.dismissLoading();
          }, 15000);
          this.onRecommendationsLoaded(data, campaignId, sectionId)
            .catch((error) => {
              console.warn('[BR Debug] recommendation render failed:', error);
              this.dismissLoading();
            })
            .finally(() => clearTimeout(renderTimer));
        }
      };

      const fetchAndSend = async () => {
        if (this.context === 'bestseller') {
          delete options.items;
        } else if (this.context === 'product' || this.context === 'personalized') {
          let lookupId = this.variantId ? String(this.variantId) : '';

          if (!lookupId && window.location.pathname.includes('/cart')) {
            try {
              const res = await fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart.js');
              const cart = await res.json();
              if (cart.items && cart.items.length > 0) {
                lookupId = String(cart.items[0].variant_id);
              }
            } catch (e) {
              console.warn('Failed to fetch cart for bloomreach seed ID');
            }
          }

          if (lookupId) {
            options.items = {
              [lookupId]: 1
            };
          }
        }

        if (window.exponea && typeof window.exponea.getRecommendation === 'function') {
          window.exponea.getRecommendation(options);
        } else {
          console.warn('Bloomreach SDK is not available.');
          clearTimeout(timer);
          this.dismissLoading();
          finish();
        }
      };

      fetchAndSend();
    });
  }

  async onRecommendationsLoaded(data, campaignId = this.campaignId, sectionId = this.sectionId) {
    if (campaignId !== this.campaignId || sectionId !== this.sectionId) return;

    if (!data || data.length === 0) {
      this.hideSection();
      return;
    }

    const ulElement = this.querySelector('ul[role="list"]');
    if (!ulElement) return;

    const entries = [];
    data.forEach((item, index) => {
      const handle = this.productHandle(item);
      if (handle) entries.push({ item, index, handle });
    });
    if (!entries.length) {
      this.dismissLoading();
      return;
    }

    const slots = new Array(entries.length);
    let revealed = false;
    let paintScheduled = false;
    const refreshSlider = () => {
      const slider = this.querySelector('slider-component');
      if (slider && typeof slider.resetPages === 'function') slider.resetPages();
    };
    const paintNow = () => {
      paintScheduled = false;
      const cards = slots.filter(Boolean);
      if (!cards.length) return;
      if (!revealed) {
        revealed = true;
        this.classList.remove('is-loading');
        this.removeAttribute('aria-busy');
      }
      ulElement.replaceChildren(...cards);
      this.toggleArrows(cards.length);
      refreshSlider();
      this.resetScrollToStart(ulElement);
      this.syncArrowDisabled(ulElement);
    };
    const schedulePaint = () => {
      if (paintScheduled) return;
      paintScheduled = true;
      requestAnimationFrame(paintNow);
    };
    const placeCard = (slotIndex, card, entry) => {
      if (!card) {
        slots[slotIndex] = null;
        return;
      }
      this.decorateCard(card, entry.item, entry.index);
      slots[slotIndex] = card;
    };

    // Paint the first visible viewport ASAP, then fill the rest.
    const firstCount = Math.min(entries.length, this.visibleSlideCount());

    // Batch search runs in parallel and never blocks the first paint.
    const batchPromise = !this.dataset.cardSection
      ? this.fetchCardBatch(entries).then((batched) => {
        if (!batched.length) return;
        const byHandle = new Map();
        batched.forEach((card) => {
          const handle = this.normalizeHandle(card && card.dataset && card.dataset.productHandle);
          if (handle && !byHandle.has(handle)) byHandle.set(handle, card);
        });
        entries.forEach((entry, slotIndex) => {
          if (slots[slotIndex]) return;
          const card = byHandle.get(entry.handle);
          if (card) placeCard(slotIndex, card.cloneNode(true), entry);
        });
        schedulePaint();
      })
      : Promise.resolve();

    await Promise.all(
      entries.slice(0, firstCount).map(async (entry, slotIndex) => {
        if (slots[slotIndex]) return;
        placeCard(slotIndex, await this.fetchProductCard(entry.handle), entry);
        schedulePaint();
      })
    );
    paintNow();

    let eventsReady = false;
    const afterPaint = () => {
      const visible = slots.filter(Boolean);
      if (!visible.length) return;
      this.mountWishlist();
      if (!eventsReady) {
        eventsReady = true;
        this.initSliderIndicator();
        if (typeof this.enableAlgoliaClickTracking === 'function') this.enableAlgoliaClickTracking();
        this.dispatchEvent(new CustomEvent('exponea:recommendations', {
          bubbles: true,
          detail: { campaignId: campaignId, items: data }
        }));
      }
      injectBloomreachData(this, null, null, null, null, null, null);
      if (typeof handleQuickAddPositioning === 'function') handleQuickAddPositioning();
    };

    afterPaint();

    await batchPromise;

    const restMissing = [];
    for (let slotIndex = 0; slotIndex < entries.length; slotIndex += 1) {
      if (!slots[slotIndex]) restMissing.push({ entry: entries[slotIndex], slotIndex });
    }

    if (restMissing.length) {
      await Promise.all(restMissing.map(async ({ entry, slotIndex }) => {
        placeCard(slotIndex, await this.fetchProductCard(entry.handle), entry);
        schedulePaint();
      }));
      paintNow();
      afterPaint();
    }

    const allItems = slots.filter(Boolean);
    if (!allItems.length) {
      this.dismissLoading();
      return;
    }

    this.toggleArrows(allItems.length);
    refreshSlider();
  }

  decorateCard(card, item, index) {
    card.id = `Slide-${this.sectionId}-${index + 1}`;
    card.dataset.recoPosition = String(index + 1);
    if (item.item_id) card.dataset.recoItemId = String(item.item_id);
    if (item.title) card.dataset.recoTitle = String(item.title);
    if (item.brand) card.dataset.recoBrand = String(item.brand);
    if (item.sku_id || item.sku) card.dataset.recoSku = String(item.sku_id || item.sku);
    if (item.price != null && item.price !== '') card.dataset.recoPrice = String(item.price);
    if (item.original_price != null && item.original_price !== '') card.dataset.recoOriginal = String(item.original_price);
  }

  normalizeHandle(handle) {
    return String(handle || '').trim().toLowerCase();
  }

  quoteSearchTerm(value) {
    const term = String(value || '').trim().replace(/"/g, '');
    if (!term) return '';
    return `"${term}"`;
  }

  cardSearchQuery(entries) {
    const clauses = entries
      .map(({ handle }) => {
        const quoted = this.quoteSearchTerm(handle);
        return quoted ? `handle:${quoted}` : '';
      })
      .filter(Boolean);
    return clauses.join(' OR ');
  }

  async fetchCardBatch(entries) {
    const query = this.cardSearchQuery(entries);
    if (!query || this.dataset.cardSection) return [];

    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const params = new URLSearchParams({
      q: query,
      type: 'product',
      section_id: BLOOMREACH_CARD_SECTION
    });
    try {
      const response = await fetch(`${root}search?${params.toString()}`, { credentials: 'same-origin' });
      if (!response.ok) return [];
      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const list = parsed.querySelector('[data-bloomreach-card-list]');
      if (!list) return [];
      return Array.from(list.querySelectorAll('li[data-bloomreach-product], li[data-product-id]'));
    } catch (error) {
      console.warn('[BR Debug] batch card render failed:', error);
      return [];
    }
  }

  fetchProductCard(handle, sectionId = this.dataset.cardSection || BLOOMREACH_CARD_SECTION) {
    const cardSectionId = sectionId;
    const cacheKey = `${cardSectionId}::${handle}`;
    let request = bloomreachCardRequestCache.get(cacheKey);
    if (!request) {
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      const url = `${root}products/${encodeURIComponent(handle)}?section_id=${encodeURIComponent(cardSectionId)}`;
      request = fetch(url, { credentials: 'same-origin' })
        .then(async (response) => {
          if (!response.ok) return null;
          return parseBloomreachCardHtml(await response.text());
        })
        .catch((error) => {
          bloomreachCardRequestCache.delete(cacheKey);
          console.warn('[BR Debug] card-product render failed:', handle, error);
          return null;
        });
      bloomreachCardRequestCache.set(cacheKey, request);
    }

    return request.then((card) => (card ? card.cloneNode(true) : null));
  }

  productHandle(item) {
    const url = String(item.url || item.link || item.product_url || '');
    const parts = url.split('/products/');
    if (parts.length < 2) return '';
    const raw = parts[parts.length - 1].split('?')[0].split('#')[0].replace(/\/$/, '').trim();
    try {
      return this.normalizeHandle(decodeURIComponent(raw));
    } catch (error) {
      return this.normalizeHandle(raw);
    }
  }

  isRtl(el = this) {
    const node = el || this;
    if (node && typeof getComputedStyle === 'function') {
      return getComputedStyle(node).direction === 'rtl';
    }
    return (document.documentElement.getAttribute('dir') || '').toLowerCase() === 'rtl';
  }

  // Cross-browser scrollLeft helpers for RTL overflow containers.
  // Chrome/Safari: 0 at start, negative toward end.
  // Firefox: 0 at start, positive toward end.
  getRtlScrollType(slider) {
    if (this._rtlScrollType) return this._rtlScrollType;
    const probe = document.createElement('div');
    probe.appendChild(document.createTextNode('ABCD'));
    probe.dir = 'rtl';
    probe.style.cssText = "font-size:14px;width:4px;height:1px;position:absolute;top:-1000px;overflow:scroll;";
    document.body.appendChild(probe);
    let type = 'reverse';
    if (probe.scrollLeft > 0) {
      type = 'default';
    } else {
      probe.scrollLeft = 1;
      if (probe.scrollLeft === 0) type = 'negative';
    }
    document.body.removeChild(probe);
    this._rtlScrollType = type;
    return type;
  }

  setScrollLeft(slider, value, behavior) {
    if (behavior && behavior !== 'auto') {
      slider.scrollTo({ left: value, behavior });
      return;
    }
    slider.scrollLeft = value;
  }

  // scrollLeft change that moves content 1px to the right.
  // Chrome RTL is -1 (0 at the start, negative toward the end). Firefox can be +1.
  // Measured per slider so arrow targets do not assume one browser's sign.
  getRtlScrollRatio(slider) {
    if (this._rtlScrollRatio != null) return this._rtlScrollRatio;
    const slide = slider && slider.querySelector('[id^="Slide-"]');
    if (!slider || !slide) return -1;
    if (slider.scrollWidth - slider.clientWidth <= 1) return -1;

    const previousBehavior = slider.style.scrollBehavior;
    const previousSnap = slider.style.scrollSnapType;
    slider.style.scrollBehavior = 'auto';
    slider.style.scrollSnapType = 'none';
    void slider.offsetWidth;

    const startScroll = slider.scrollLeft;
    const startRight = slide.getBoundingClientRect().right;
    const measureShift = (sample) => {
      slider.scrollLeft = startScroll + sample;
      const shift = slide.getBoundingClientRect().right - startRight;
      slider.scrollLeft = startScroll;
      return shift;
    };

    let sample = -10;
    let shift = measureShift(sample);
    if (Math.abs(shift) < 0.5) {
      sample = 10;
      shift = measureShift(sample);
    }

    slider.style.scrollSnapType = previousSnap;
    slider.style.scrollBehavior = previousBehavior;

    if (Math.abs(shift) < 0.5) return -1;
    this._rtlScrollRatio = sample / shift;
    return this._rtlScrollRatio;
  }

  // Absolute scrollLeft that aligns a slide's start edge with the slider's start edge.
  getSlideScrollLeft(slider, slide) {
    const sliderRect = slider.getBoundingClientRect();
    const slideRect = slide.getBoundingClientRect();
    if (this.isRtl(slider)) {
      const neededMove = sliderRect.right - slideRect.right;
      return slider.scrollLeft + neededMove * this.getRtlScrollRatio(slider);
    }
    return slider.scrollLeft + (slideRect.left - sliderRect.left);
  }

  clampScrollLeft(slider, value) {
    const maxScroll = Math.max(0, slider.scrollWidth - slider.clientWidth);
    const rounded = Math.round(value);
    if (!this.isRtl(slider)) {
      return Math.max(0, Math.min(rounded, maxScroll));
    }
    // Keep the sign the browser uses. Negative-model RTL (Chrome) must not be
    // clamped up to 0, or every "next" target becomes the current position.
    if (rounded < 0) return Math.max(rounded, -maxScroll);
    return Math.min(Math.max(rounded, 0), maxScroll);
  }

  // Progress 0..1 from reading-start to reading-end (visual, works in all RTL modes).
  getScrollProgress(slider) {
    const maxScroll = slider.scrollWidth - slider.clientWidth;
    if (maxScroll <= 1) return 0;

    const first = slider.querySelector('[id^="Slide-"]');
    if (first) {
      const sliderRect = slider.getBoundingClientRect();
      const firstRect = first.getBoundingClientRect();
      // How far the first slide has moved away from the inline-start edge.
      const scrolled = this.isRtl(slider)
        ? firstRect.right - sliderRect.right
        : sliderRect.left - firstRect.left;
      return Math.min(1, Math.max(0, scrolled / maxScroll));
    }

    if (!this.isRtl(slider)) return Math.min(1, Math.max(0, slider.scrollLeft / maxScroll));
    const type = this.getRtlScrollType(slider);
    if (type === 'negative') return Math.min(1, Math.max(0, -slider.scrollLeft / maxScroll));
    if (type === 'default') return Math.min(1, Math.max(0, (maxScroll - slider.scrollLeft) / maxScroll));
    return Math.min(1, Math.max(0, slider.scrollLeft / maxScroll));
  }

  isSlideFullyVisible(slider, slide) {
    const sliderRect = slider.getBoundingClientRect();
    const slideRect = slide.getBoundingClientRect();
    const epsilon = 2;
    return slideRect.left >= sliderRect.left - epsilon && slideRect.right <= sliderRect.right + epsilon;
  }

  syncArrowDisabled(slider) {
    const prevBtn = this.querySelector('.slider-button--prev');
    const nextBtn = this.querySelector('.slider-button--next');
    if (!prevBtn || !nextBtn || !this.classList.contains('is-carousel')) return;

    const slides = Array.from(slider.querySelectorAll('[id^="Slide-"]')).filter((slide) => slide.clientWidth > 0);
    if (slides.length < 2) return;

    const atStart = this.isSlideFullyVisible(slider, slides[0]);
    const atEnd = this.isSlideFullyVisible(slider, slides[slides.length - 1]);

    if (atStart) prevBtn.setAttribute('disabled', 'disabled');
    else prevBtn.removeAttribute('disabled');

    if (atEnd) nextBtn.setAttribute('disabled', 'disabled');
    else nextBtn.removeAttribute('disabled');
  }

  resetScrollToStart(slider) {
    if (!slider) return;
    const first = slider.querySelector('[id^="Slide-"]');
    slider.style.scrollBehavior = 'auto';
    slider.style.scrollSnapType = 'none';
    let target = 0;
    if (first && this.isRtl(slider)) {
      target = this.clampScrollLeft(slider, this.getSlideScrollLeft(slider, first));
    }
    slider.scrollLeft = target;
    if (!this._rtlSnapDisabled) slider.style.scrollSnapType = '';
    slider.style.scrollBehavior = '';
    if (this.isRtl(slider)) this.holdRtlScroll(slider, target, this._arrowToken);
  }

  enableMouseScroll() {
    const slider = this.querySelector('[id^="Slider-"]');
    if (!slider || slider.dataset.mouseScrollBound === 'true') return;
    slider.dataset.mouseScrollBound = 'true';

    const dragThreshold = 6;
    let pointerId = null;
    let startX = 0;
    let startScrollLeft = 0;
    let scrollFactor = -1;
    let dragged = false;

    const getAnchor = () => slider.querySelector('[id^="Slide-"]') || slider.firstElementChild;

    // Learn how scrollLeft maps to on-screen movement so drag follows the pointer
    // in every browser RTL/LTR scrollLeft mode.
    const calibrateScrollFactor = () => {
      const anchor = getAnchor();
      if (!anchor) {
        scrollFactor = -1;
        return;
      }
      const sample = 10;
      const leftBefore = anchor.getBoundingClientRect().left;
      const scrollBefore = slider.scrollLeft;
      slider.scrollLeft = scrollBefore + sample;
      const leftAfter = anchor.getBoundingClientRect().left;
      slider.scrollLeft = scrollBefore;
      const contentShift = leftAfter - leftBefore;
      // contentShift ≈ how far content moves when scrollLeft increases by `sample`.
      // We want content to move by the same delta as the mouse.
      scrollFactor = Math.abs(contentShift) < 0.5 ? -1 : sample / contentShift;
    };

    const endDrag = (event) => {
      if (pointerId === null || event.pointerId !== pointerId) return;
      if (slider.hasPointerCapture(pointerId)) slider.releasePointerCapture(pointerId);
      pointerId = null;
      const left = slider.scrollLeft;
      slider.classList.remove('is-dragging');
      if (this.isRtl(slider)) this.holdRtlScroll(slider, left, this._arrowToken);
    };

    slider.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      if (event.target.closest('button, input, select, textarea')) return;
      pointerId = event.pointerId;
      startX = event.clientX;
      startScrollLeft = slider.scrollLeft;
      dragged = false;
    });

    slider.addEventListener('pointermove', (event) => {
      if (pointerId === null || event.pointerId !== pointerId) return;
      const mouseDelta = event.clientX - startX;
      if (!dragged) {
        if (Math.abs(mouseDelta) < dragThreshold) return;
        dragged = true;
        slider.classList.add('is-dragging');
        slider.setPointerCapture(pointerId);
        startX = event.clientX;
        startScrollLeft = slider.scrollLeft;
        calibrateScrollFactor();
        return;
      }
      slider.scrollLeft = startScrollLeft + mouseDelta * scrollFactor;
    });

    slider.addEventListener('pointerup', endDrag);
    slider.addEventListener('pointercancel', endDrag);
    slider.addEventListener('dragstart', (event) => event.preventDefault());

    slider.addEventListener(
      'click',
      (event) => {
        if (!dragged) return;
        event.preventDefault();
        event.stopPropagation();
        dragged = false;
      },
      true
    );
  }

  bindReliableArrowScroll() {
    if (this._arrowScrollBound) return;
    const slider = this.querySelector('[id^="Slider-"]');
    const sliderComponent = this.querySelector('slider-component');
    if (!slider || !sliderComponent) return;
    this._arrowScrollBound = true;

    this.installArrowScrollGuard(sliderComponent);

    slider.addEventListener('pointerdown', (event) => {
      if (!this._arrowAnimating || event.pointerType !== 'mouse' || event.button !== 0) return;
      this.releaseArrowScroll(slider);
    });

    this.addEventListener(
      'click',
      (event) => {
        const target = event.target;
        const button = target instanceof Element
          ? target.closest('button.slider-button')
          : null;

        if (!button || !this.contains(button)) return;
        if (button.name !== 'next' && button.name !== 'previous') return;
        if (button.hasAttribute('disabled')) return;

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        this.installArrowScrollGuard(sliderComponent);

        requestAnimationFrame(() => {
          this.scrollByArrow(slider, button);
        });
      },
      true
    );
  }

  installArrowScrollGuard(sliderComponent) {
    if (!sliderComponent || sliderComponent._bloomreachArrowGuard) return;
    if (typeof sliderComponent.setSlidePosition !== 'function') {
      customElements.whenDefined('slider-component').then(() => {
        this.installArrowScrollGuard(sliderComponent);
      });
      return;
    }

    sliderComponent._bloomreachArrowGuard = true;
    const host = this;
    const nativeSetSlidePosition = sliderComponent.setSlidePosition.bind(sliderComponent);
    sliderComponent.setSlidePosition = function (position) {
      if (host._suppressNativeArrow) {
        host._suppressNativeArrow = false;
        return;
      }
      nativeSetSlidePosition(position);
    };

    // Theme slider disabled-state math is LTR-only; re-sync after it runs.
    if (!sliderComponent._bloomreachUpdateGuard && typeof sliderComponent.update === 'function') {
      sliderComponent._bloomreachUpdateGuard = true;
      const nativeUpdate = sliderComponent.update.bind(sliderComponent);
      sliderComponent.update = function () {
        nativeUpdate();
        const slider = host.querySelector('[id^="Slider-"]');
        if (slider) host.syncArrowDisabled(slider);
      };

      // The SliderComponent constructor binds `update` to its scroll listener
      // via `.bind()`, which captures the original (unpatched) function reference.
      // Patching `sliderComponent.update` above does NOT affect that listener,
      // so the RTL-aware `syncArrowDisabled` never runs during scroll events.
      // Add a separate scroll listener that always corrects the disabled state.
      const sliderEl = sliderComponent.slider || sliderComponent.querySelector('[id^="Slider-"]');
      if (sliderEl) {
        sliderEl.addEventListener('scroll', () => {
          host.syncArrowDisabled(sliderEl);
        }, { passive: true });
      }
    }
  }

  releaseArrowScroll(slider) {
    this._arrowAnimating = false;
    this._arrowTarget = null;
    this._arrowToken = (this._arrowToken || 0) + 1;
    if (this._arrowScrollTimer) {
      clearTimeout(this._arrowScrollTimer);
      this._arrowScrollTimer = null;
    }
    if (this._arrowScrollEnd && slider) {
      slider.removeEventListener('scrollend', this._arrowScrollEnd);
      this._arrowScrollEnd = null;
    }
    if (!slider || slider.classList.contains('is-dragging')) return;
    const left = slider.scrollLeft;
    slider.style.scrollBehavior = 'auto';
    slider.scrollLeft = left;
    slider.style.scrollBehavior = '';
    slider.style.scrollSnapType = this._rtlSnapDisabled ? 'none' : '';
  }

  // Snap points are physical in some RTL engines and will pull a correct
  // scrollLeft back to the other end. If that happens, keep the position.
  holdRtlScroll(slider, target, token) {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (!slider || !this.isRtl(slider)) return;
        if (token != null && this._arrowToken !== token) return;
        if (Math.abs(slider.scrollLeft - target) <= 3) return;
        this._rtlSnapDisabled = true;
        slider.style.scrollSnapType = 'none';
        slider.style.scrollBehavior = 'auto';
        slider.scrollLeft = target;
        slider.style.scrollBehavior = '';
        this.syncArrowDisabled(slider);
      });
    });
  }

  // Chrome drops a negative scrollTo({ left }) while scroll-behavior is smooth.
  // That is how RTL overflow is represented, so arrows write scrollLeft themselves.
  animateRtlScroll(slider, target, token) {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    slider.style.scrollSnapType = 'none';
    slider.style.scrollBehavior = 'auto';

    const finish = () => {
      if (this._arrowToken !== token) return;
      slider.style.scrollBehavior = 'auto';
      slider.scrollLeft = target;
      if (!this._rtlSnapDisabled && !slider.classList.contains('is-dragging')) slider.style.scrollSnapType = '';
      slider.style.scrollBehavior = '';
      this._arrowAnimating = false;
      this._arrowTarget = slider.scrollLeft;
      this.syncArrowDisabled(slider);
      this.holdRtlScroll(slider, target, token);
    };

    const start = slider.scrollLeft;
    if (reducedMotion || Math.abs(target - start) < 1) {
      finish();
      return;
    }

    const distance = target - start;
    const duration = 450;
    const startedAt = performance.now();
    const step = (now) => {
      if (this._arrowToken !== token) return;
      const progress = Math.min(1, (now - startedAt) / duration);
      const eased = 1 - Math.pow(1 - progress, 3);
      slider.scrollLeft = start + distance * eased;
      if (progress < 1) {
        requestAnimationFrame(step);
        return;
      }
      finish();
    };
    requestAnimationFrame(step);
    this._arrowScrollTimer = window.setTimeout(() => {
      if (this._arrowToken !== token) return;
      if (Math.abs(slider.scrollLeft - target) <= 2) return;
      finish();
    }, 700);
  }

  scrollByArrow(slider, button) {
    const slides = Array.from(slider.querySelectorAll('[id^="Slide-"]')).filter((slide) => slide.clientWidth > 0);
    if (slides.length < 2) return false;

    const positions = slides.map((slide) => this.clampScrollLeft(slider, this.getSlideScrollLeft(slider, slide)));
    const current = this._arrowAnimating && this._arrowTarget != null ? this._arrowTarget : slider.scrollLeft;

    let index = 0;
    let nearest = Infinity;
    positions.forEach((position, slideIndex) => {
      const delta = Math.abs(position - current);
      if (delta < nearest) {
        nearest = delta;
        index = slideIndex;
      }
    });

    const step = Number(button.dataset.step) || 1;
    // Advance by product index so "next" follows recommendation order in both LTR and RTL.
    const direction = button.name === 'next' ? 1 : -1;
    const nextIndex = Math.max(0, Math.min(positions.length - 1, index + direction * step));
    const target = this.clampScrollLeft(slider, positions[nextIndex]);
    const startLeft = slider.scrollLeft;

    if (Math.abs(target - current) < 1 && Math.abs(target - startLeft) < 1) {
      this.syncArrowDisabled(slider);
      return true;
    }

    const token = (this._arrowToken || 0) + 1;
    this._arrowToken = token;
    this._arrowTarget = target;
    this._arrowAnimating = true;

    if (this._arrowScrollTimer) clearTimeout(this._arrowScrollTimer);
    if (this._arrowScrollEnd) slider.removeEventListener('scrollend', this._arrowScrollEnd);

    if (this.isRtl(slider)) {
      this.animateRtlScroll(slider, target, token);
      return true;
    }

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const behavior = reduceMotion ? 'auto' : 'smooth';
    const finish = (force) => {
      if (this._arrowToken !== token) return;
      const settled = Math.abs(slider.scrollLeft - target) <= 2;
      if (!force && !settled) return;
      if (!settled) {
        slider.style.scrollSnapType = 'none';
        slider.style.scrollBehavior = 'auto';
        slider.scrollLeft = target;
        slider.style.scrollBehavior = '';
      }
      this._arrowAnimating = false;
      if (this._arrowScrollEnd) {
        slider.removeEventListener('scrollend', this._arrowScrollEnd);
        this._arrowScrollEnd = null;
      }
      if (!slider.classList.contains('is-dragging')) slider.style.scrollSnapType = '';
      this._arrowTarget = slider.scrollLeft;
      this.syncArrowDisabled(slider);
    };
    const onScrollEnd = () => finish(false);
    this._arrowScrollEnd = onScrollEnd;
    slider.addEventListener('scrollend', onScrollEnd);

    // Mandatory snap plus smooth scrolling drops the first arrow click in Chrome.
    slider.style.scrollSnapType = 'none';
    slider.style.scrollBehavior = 'auto';
    slider.scrollLeft = startLeft;
    slider.style.scrollBehavior = '';
    slider.scrollTo({ left: target, behavior });

    this._arrowScrollTimer = window.setTimeout(() => finish(true), 1000);
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (this._arrowToken !== token) return;
        if (Math.abs(target - startLeft) <= 1) return;
        if (Math.abs(slider.scrollLeft - startLeft) >= 1) return;
        slider.style.scrollSnapType = 'none';
        slider.scrollTo({ left: target, behavior });
      });
    });

    return true;
  }

  initSliderIndicator() {
    const slider = this.querySelector('ul[id^="Slider-"]');
    const track = this.querySelector('.bloomreach-scrollbar');
    const sliderIndicator = track && track.querySelector('.bloomreach-scrollbar__thumb');
    if (!slider || !track || !sliderIndicator || slider.dataset.indicatorBound === 'true') return;
    slider.dataset.indicatorBound = 'true';

    const update = () => {
      const maxScroll = slider.scrollWidth - slider.clientWidth;
      const show = maxScroll > 1 && this.classList.contains('is-carousel');
      if (show) track.style.removeProperty('display');
      else track.style.display = 'none';
      if (!show) return;

      const visibleRatio = slider.scrollWidth > 0 ? slider.clientWidth / slider.scrollWidth : 1;
      const indicatorWidth = Math.max(track.clientWidth * visibleRatio, 24);
      sliderIndicator.style.width = `${indicatorWidth}px`;
      const travel = Math.max(track.clientWidth - indicatorWidth, 0);
      const scrollPercentage = Math.min(1, Math.max(0, this.getScrollProgress(slider)));
      const offset = `${scrollPercentage * travel}px`;
      if (this.isRtl(slider)) {
        sliderIndicator.style.left = 'auto';
        sliderIndicator.style.right = offset;
        sliderIndicator.style.transform = 'none';
      } else {
        sliderIndicator.style.right = 'auto';
        sliderIndicator.style.left = offset;
        sliderIndicator.style.transform = 'none';
      }
      this.syncArrowDisabled(slider);
    };

    update();
    slider.addEventListener('scroll', update, { passive: true });
    if (typeof ResizeObserver !== 'undefined') {
      const observer = new ResizeObserver(update);
      observer.observe(slider);
    } else {
      window.addEventListener('resize', update);
    }

    const details = this.closest('details');
    if (details) details.addEventListener('toggle', update);
  }

  mountWishlist() {
    this.querySelectorAll('.wishlistDiv').forEach((el) => {
      if (!el.childElementCount) el.innerHTML = BLOOMREACH_HEART_OUTLINE;
    });
    // Apply cached wishlist state immediately, then refresh Wishlister for click sync.
    if (window.__bloomreachWishlistState) {
      applyBloomreachWishlistState(this, window.__bloomreachWishlistState);
    }
    syncBloomreachWishlist(this);
    if (window.exponea && typeof window.exponea.reloadWebLayers === 'function') {
      window.exponea.reloadWebLayers();
    }
  }
  enableAlgoliaClickTracking() {
    // Use delegation so future re-renders also work
    this.addEventListener('click', function (e) {
      const link = e.target.closest('.card__content a');
      if (!link) return;

      const userToken = localStorage.getItem('_ALGOLIA_USER_TOKEN') || 'anonymous';
      const objectID = link.dataset.variantId;
      const index = window.algoliaShopify.dynamicIndexName || `${window.algoliaShopify.config.index_prefix}products`;
      const authenticatedUserToken = window.algoliaShopify?.authenticatedUserToken || undefined;
      aa('clickedObjectIDs', {
        userToken: userToken,
        authenticatedUserToken: authenticatedUserToken,
        eventName: 'clickedObjectIDs',
        index: index,
        objectIDs: [objectID]
      });
    });
  }
  hideSection() {
    const section = document.getElementById(`shopify-section-${this.sectionId}`);
    if (section) {
      section.style.display = 'none';
      return;
    }
    const topProducts = this.closest('.top-products');
    if (topProducts) topProducts.style.display = 'none';
  }
  dismissLoading() {
    if (!this.classList.contains('is-loading')) return;
    this.hideSection();
  }
  visibleSlideCount() {
    if (!this.dataset.slidesDesktop) return 4;
    const width = window.innerWidth;
    if (width < 750) return Number(this.dataset.slidesMobile || 2);
    if (width < 990) return Number(this.dataset.slidesTablet || 4);
    return Number(this.dataset.slidesDesktop);
  }
  toggleArrows(productCount) {
    const prevBtn = this.querySelector('.slider-button--prev');
    const nextBtn = this.querySelector('.slider-button--next');
    if (!prevBtn || !nextBtn) return;

    const isCarousel = productCount > this.visibleSlideCount();

    if (this.dataset.arrowsWhenCarousel === 'true') {
      this.classList.toggle('is-carousel', isCarousel);
      prevBtn.style.display = '';
      nextBtn.style.display = '';
      const slider = this.querySelector('slider-component');
      if (slider && typeof slider.resetPages === 'function') slider.resetPages();
      if (!isCarousel) {
        prevBtn.setAttribute('disabled', 'disabled');
        nextBtn.setAttribute('disabled', 'disabled');
        const track = this.querySelector('.bloomreach-scrollbar');
        if (track) track.style.display = 'none';
      }
      return;
    }

    prevBtn.style.display = 'flex';
    nextBtn.style.display = 'flex';
    if (!isCarousel) {
      nextBtn.setAttribute('disabled', 'disabled');
    } else {
      nextBtn.removeAttribute('disabled');
    }
  }

}
customElements.define('bloomreach-products', BloomreachRecommendations);

function injectBloomreachData(container = null, quickViewHandle = null, quickViewHandleForm = null, quickViewItemId = null, curVID = null, metaColor = null, categoryData) {
  if (container !== null && quickViewHandle === null) {
    container.querySelectorAll('[data-bloomreach-product]').forEach((el) => {
      const handle = el.getAttribute('data-product-handle');
      const productId = el.getAttribute('data-product-id');
      const metaColor = el.getAttribute('data-meta-color');
      const categoryData = {
        category_level_1: el.getAttribute('data-cat-level-1') || '',
        category_level_2: el.getAttribute('data-cat-level-2') || '',
        category_level_3: el.getAttribute('data-cat-level-3') || '',
        categories_path: el.getAttribute('data-cat-path') || '',
        category_id: el.getAttribute('data-cat-id') || '',
        categories_ids: (el.getAttribute('data-cat-ids') || '').split(',')  // returns array like ["cat_makeup", "cat_lips"]
      };

      if (!handle || document.getElementById(`bloomreach_product_json_${productId}`)) return;
      injectBloomreachItem(handle, productId, el, null, metaColor, categoryData);
    });
  }
  else if (container === null && quickViewHandle !== null) {
    injectBloomreachItem(quickViewHandle, quickViewItemId, quickViewHandleForm, curVID, metaColor, categoryData);
  }
}

function fetchBloomreachProduct(handle) {
  const cached = bloomreachProductJsonCache.get(handle);
  if (cached) return cached;

  const request = fetch(`${window.Shopify.routes.root}products/${handle}.js`)
    .then((response) => {
      if (!response.ok) throw new Error(`Failed to fetch product ${handle}`);
      return response.json();
    })
    .catch((error) => {
      bloomreachProductJsonCache.delete(handle);
      throw error;
    });

  bloomreachProductJsonCache.set(handle, request);
  return request;
}

function injectBloomreachItem(handle, productId, elOrFormContainer, curVID = null, metaColor, bloomCatData) {
  const productFormBR = elOrFormContainer.tagName === 'FORM'
    ? elOrFormContainer
    : elOrFormContainer.querySelector(`form[data-id="product-form-${productId}"]`);

  if (!productFormBR) return;

  fetchBloomreachProduct(handle)
    .then(product => {
      const variant = curVID
        ? product.variants.find(v => v.id === curVID.id)
        : product.variants.find(v => v.available) || product.variants[0];

      const getVariantColor = (metaColor, variant, product) => {
        if (metaColor && metaColor.trim() !== '') {
          return metaColor;
        }
        if (!variant) return;
        const colorKeywords = ['color', 'colour'];
        const colorOptionIndex = product?.options?.findIndex(option =>
          colorKeywords.some(keyword =>
            option.name.toLowerCase().includes(keyword)
          )
        ) ?? -1;

        if (colorOptionIndex === -1) return '';
        const colorValue = variant?.options?.[colorOptionIndex] ||
          variant?.[`option${colorOptionIndex + 1}`];

        return colorValue || '';
      };

      const finalColor = getVariantColor(metaColor, variant, product);
      const sizeOptionIndex = product.options.findIndex(opt => opt.name === 'Size' || opt.name === 'مقاس');
      const currentVariantLabel = variant.options[sizeOptionIndex] || null;
      const tags = product.tags || [];

      const price = ((parseFloat(variant.price) || 0) / 100).toFixed(2);
      const compare_at_price = (variant.compare_at_price && parseFloat(variant.compare_at_price) > parseFloat(variant.price))
        ? (parseFloat(variant.compare_at_price) / 100).toFixed(2)
        : '';

      const bloomreach_item_json = {
        product_id: variant.barcode,
        variant_id: variant.sku,
        sku_id: variant.sku,
        shopify_parent_id: product.id,
        shopify_variant_id: variant.id,
        title: product.title,
        price: price,
        price_local_currency: price,
        compare_at_price,
        brand: product.vendor,
        product_type: product.type,
        color: finalColor || '',
        size: currentVariantLabel,
        tags,
        ...bloomCatData
      };
      const existingInput = productFormBR.querySelector(`#bloomreach_product_json_${product.id}`);
      if (existingInput) {
        if (curVID) {
          existingInput.remove();
        }
        else {
          return;
        }
      }

      const input = document.createElement("input");
      input.type = "hidden";
      input.name = `properties[_bloomreach_product_json]`;
      input.id = `bloomreach_product_json_${product.id}`;
      input.value = JSON.stringify(bloomreach_item_json);
      productFormBR.appendChild(input);
    })
    .catch(error => {
      console.error(`Failed to fetch product ${handle}:`, error);
    });
}

// BFCache fix: reload page when navigating via Back/Forward button
window.addEventListener('pageshow', function (event) {
  if (event.persisted) {
    window.location.reload();
  }
});















// --- Algolia Event Tracking Helpers ---

function getAlgoliaIndexName() {
  let indexName = '';
  if (window.algoliaShopify?.dynamicIndexName) {
    indexName = window.algoliaShopify.dynamicIndexName;
  } else {
    const isSearchContext = sessionStorage.getItem('algolia_queryID') ? true : false;
    if (isSearchContext && sessionStorage.getItem('algolia_index')) {
      indexName = sessionStorage.getItem('algolia_index');
    } else {
      indexName = `${window.algoliaShopify?.config?.index_prefix || 'shopify_'}products`;
    }
  }

  return indexName;
}

function getAlgoliaUserToken() {
  return localStorage.getItem('_ALGOLIA_USER_TOKEN') || 'anonymous';
}

function getAlgoliaAuthenticatedToken() {
  return window.algoliaShopify?.authenticatedUserToken || undefined;
}

function sendClickedObjectIDs(objectIDs, eventName = 'clickedObjectIDs') {
  if (typeof aa === 'undefined') return;
  aa('clickedObjectIDs', {
    userToken: getAlgoliaUserToken(),
    authenticatedUserToken: getAlgoliaAuthenticatedToken(),
    eventName: eventName,
    index: getAlgoliaIndexName(),
    objectIDs: Array.isArray(objectIDs) ? objectIDs : [String(objectIDs)]
  });
}

function sendConvertedObjectIDs(objectIDs, eventName = 'convertedObjectIDs') {
  if (typeof aa === 'undefined') return;
  const indexName = getAlgoliaIndexName();
  const payload = {
    userToken: getAlgoliaUserToken(),
    authenticatedUserToken: getAlgoliaAuthenticatedToken(),
    eventName: eventName,
    index: indexName,
    objectIDs: Array.isArray(objectIDs) ? objectIDs : [String(objectIDs)]
  };


  aa('convertedObjectIDs', payload);
}

function sendConvertedObjectIDsAfterSearch(objectID, properties = {}, eventName = 'convertedObjectIDsAfterSearch') {
  if (typeof aa === 'undefined') return;
  const queryID = sessionStorage.getItem('algolia_queryID');
  if (!queryID) return; // If no queryID, it's not "AfterSearch"

  const price = parseFloat(properties.price || 0);
  const qty = parseInt(properties.quantity || 1, 10);
  const value = Number((price * qty).toFixed(2));

  aa('convertedObjectIDsAfterSearch', {
    userToken: getAlgoliaUserToken(),
    authenticatedUserToken: getAlgoliaAuthenticatedToken(),
    eventName: eventName,
    index: getAlgoliaIndexName(),
    queryID: queryID,
    objectIDs: [String(objectID)]
  });
}

function sendAddedToCartObjectIDs(objectIDs, properties = {}, eventName = 'addedToCartObjectIDs') {
  if (typeof aa === 'undefined') return;
  const price = parseFloat(properties.price || 0);
  const qty = parseInt(properties.quantity || 1, 10);
  const value = Number((price * qty).toFixed(2));

  const indexName = getAlgoliaIndexName();
  const payload = {
    userToken: getAlgoliaUserToken(),
    authenticatedUserToken: getAlgoliaAuthenticatedToken(),
    eventName: eventName,
    index: indexName,
    objectIDs: Array.isArray(objectIDs) ? objectIDs : [String(objectIDs)],
    objectData: [{
      price: price,
      discount: properties.discount_value || 0,
      quantity: qty
    }],
    value: value,
    currency: properties.currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
  };




  aa('addedToCartObjectIDs', payload);
}

function sendAddedToCartObjectIDsAfterSearch(objectID, properties = {}, eventName = 'addedToCartObjectIDsAfterSearch') {
  if (typeof aa === 'undefined') return;
  const queryID = sessionStorage.getItem('algolia_queryID');
  if (!queryID) return;

  const price = parseFloat(properties.price || 0);
  const qty = parseInt(properties.quantity || 1, 10);
  const value = Number((price * qty).toFixed(2));

  aa('addedToCartObjectIDsAfterSearch', {
    userToken: getAlgoliaUserToken(),
    authenticatedUserToken: getAlgoliaAuthenticatedToken(),
    eventName: eventName,
    eventSubtype: 'addToCart',
    index: getAlgoliaIndexName(),
    queryID: queryID,
    objectIDs: [String(objectID)],
    objectData: [{
      price: price,
      discount: properties.discount_value || 0,
      quantity: qty
    }],
    value: value,
    currency: properties.currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
  });

}

function sendPurchasedObjectIDs(objectIDs, properties = {}, eventName = 'purchasedObjectIDs') {
  if (typeof aa === 'undefined') return;
  const price = parseFloat(properties.price || 0);
  const qty = parseInt(properties.quantity || 1, 10);
  const value = Number((price * qty).toFixed(2));

  aa('purchasedObjectIDs', {
    userToken: getAlgoliaUserToken(),
    authenticatedUserToken: getAlgoliaAuthenticatedToken(),
    eventName: eventName,
    index: getAlgoliaIndexName(),
    objectIDs: Array.isArray(objectIDs) ? objectIDs : [String(objectIDs)],
    objectData: [{
      price: price,
      discount: properties.discount_value || 0,
      quantity: qty
    }],
    value: value,
    currency: properties.currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
  });
}

function sendPurchasedObjectIDsAfterSearch(objectID, properties = {}, eventName = 'purchasedObjectIDsAfterSearch') {
  if (typeof aa === 'undefined') return;
  const queryID = properties.queryID || sessionStorage.getItem('algolia_queryID');
  if (!queryID) return;

  const price = parseFloat(properties.price || 0);
  const qty = parseInt(properties.quantity || 1, 10);
  const value = Number((price * qty).toFixed(2));

  aa('purchasedObjectIDsAfterSearch', {
    userToken: getAlgoliaUserToken(),
    authenticatedUserToken: getAlgoliaAuthenticatedToken(),
    eventName: eventName,
    index: getAlgoliaIndexName(),
    queryID: queryID,
    objectIDs: [String(objectID)],
    objectData: [{
      price: price,
      discount: properties.discount_value || 0,
      quantity: qty
    }],
    value: value,
    currency: properties.currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
  });
}

// Global click listener for Product cards to trigger `clickedObjectIDs`
document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener('click', function (e) {
    if (e._algoliaClickTracked) return;

    const productLink = e.target.closest('.card__content a, .product-grid .card__content a, .product-card-link, .algolia-standard-product-link');
    if (productLink) {
      const variantId = productLink.dataset.variantId || productLink.getAttribute('algolia-product-objectid');
      if (variantId) {
        e._algoliaClickTracked = true;
        sendClickedObjectIDs(variantId);
      }
    }
  });

  // --- START CUSTOM ALGOLIA TRACKING FIXES ---
  // Tracks product clicks (clickedObjectIDs/AfterSearch)
  // Tracks add to cart (addedToCart/converted ObjectIDs)
  // Tracks active sidebar filters (clickedFilters)
  document.addEventListener('click', function (e) {
    if (e._algoliaClickTracked) return;

    const algoliaLink = e.target.closest('.algolia-product-link, .ais-hit--image');
    // If they clicked the add to cart button, ignore this click listener
    if (e.target.closest('.algolia-add-to-cart, .ais-hit--cart-button, .ais-hit--cart-button_custom')) return;

    if (!algoliaLink) return;

    e._algoliaClickTracked = true;

    // We can pull data from the link itself or its parent product card
    const productCard = algoliaLink.closest('.ais-product') || algoliaLink;

    const queryID = productCard.getAttribute('data-algolia-queryid');
    const objectID = productCard.getAttribute('data-algolia-objectid');
    const position = productCard.getAttribute('data-algolia-position');
    const source = productCard.getAttribute('data-source') || '';

    const isSearch = source === 'search' || document.location.pathname.includes('/search') || productCard.closest('#header-instant-search-container') !== null;

    if (queryID && objectID) {
      if (isSearch) {
        sessionStorage.setItem('algolia_queryID', queryID);
        sessionStorage.setItem('algolia_objectID', objectID);
        sessionStorage.setItem('algolia_index', window.algoliaShopify?.dynamicIndexName || productCard.getAttribute('data-algolia-index') || getAlgoliaIndexName());
      } else {
        sessionStorage.removeItem('algolia_queryID');
        sessionStorage.removeItem('algolia_objectID');
        sessionStorage.removeItem('algolia_index');
      }

      if (typeof aa !== 'undefined') {
        const payload = {
          userToken: getAlgoliaUserToken(),
          authenticatedUserToken: getAlgoliaAuthenticatedToken(),
          index: getAlgoliaIndexName(),
          objectIDs: [objectID],
        };

        if (isSearch) {
          payload.eventName = 'clickedObjectIDsAfterSearch';
          payload.queryID = queryID;
          payload.positions = [parseInt(position, 10) || 1];
          aa('clickedObjectIDsAfterSearch', payload);
        } else {
          payload.eventName = 'clickedObjectIDs';
          // Collections don't strictly require queryID/positions for standard click tracking
          aa('clickedObjectIDs', payload);
        }
      }
    }
  });

  // Track "Move to Cart" button from the Wishlist Page
  document.addEventListener('click', function (e) {
    const wishlistATC = e.target.closest('.wishlist-atc-event');
    if (!wishlistATC) return;

    const variantID = wishlistATC.getAttribute('data-variantid') || wishlistATC.getAttribute('data-variproid');
    if (!variantID) return;

    const price = parseFloat(wishlistATC.getAttribute('data-proprice') || 0);
    const currency = wishlistATC.getAttribute('data-currency') || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AED';
    const discount = parseFloat(wishlistATC.getAttribute('data-discount') || 0);

    const props = {
      price: price,
      discount_value: discount,
      quantity: 1,
      currency: currency
    };

    if (typeof sendAddedToCartObjectIDs === 'function') {
      sendAddedToCartObjectIDs(variantID, props);
    }
    if (typeof sendConvertedObjectIDs === 'function') {
      sendConvertedObjectIDs(variantID);
    }
  }, true);

  // Track clicking the Wishlist Heart Icon on standard and Algolia product cards
  document.addEventListener('click', function (e) {
    const wishlistHeart = e.target.closest('.mswishlistbutton');
    if (!wishlistHeart) return;

    const variantID = wishlistHeart.getAttribute('data-variant');
    if (!variantID) return;

    // Check if this is an Algolia search card
    const productCard = wishlistHeart.nextElementSibling;
    let isSearchContext = false;
    let queryID = null;

    if (productCard && productCard.classList.contains('ais-product')) {
      queryID = productCard.getAttribute('data-algolia-queryid');
      const source = productCard.getAttribute('data-source') || '';
      isSearchContext = source === 'search' || document.location.pathname.includes('/search') || productCard.closest('#header-instant-search-container') !== null;
    }

    if (isSearchContext && queryID) {
      if (typeof aa !== 'undefined') {
        aa('convertedObjectIDsAfterSearch', {
          userToken: getAlgoliaUserToken(),
          authenticatedUserToken: getAlgoliaAuthenticatedToken(),
          eventName: 'convertedObjectIDsAfterSearch',
          index: getAlgoliaIndexName(),
          queryID: queryID,
          objectIDs: [variantID]
        });
      }
    } else {
      const sessionQueryID = sessionStorage.getItem('algolia_queryID');
      if (sessionQueryID) {
        if (typeof sendConvertedObjectIDsAfterSearch === 'function') {
          const wPrice = parseFloat(wishlistHeart.getAttribute('data-price')) || 0;
          const wComparePrice = parseFloat(wishlistHeart.getAttribute('data-compare-at-price')) || 0;
          let discount = 0;
          if (wComparePrice > wPrice) discount = Number((wComparePrice - wPrice).toFixed(2));
          sendConvertedObjectIDsAfterSearch(variantID, { price: wPrice, discount_value: discount });
        }
      } else {
        if (typeof sendConvertedObjectIDs === 'function') {
          sendConvertedObjectIDs(variantID);
        }
      }
    }
  });

  // Track Add To Cart and Conversions from Algolia InstantSearch
  document.addEventListener('click', function (e) {
    const addToCartBtn = e.target.closest('.ais-hit--cart-button_custom, .algolia-add-to-cart button');
    if (!addToCartBtn) return;

    const productCard = addToCartBtn.closest('.ais-product');
    if (!productCard) return;

    const queryID = productCard.getAttribute('data-algolia-queryid');
    const objectID = productCard.getAttribute('data-algolia-objectid');
    const index = getAlgoliaIndexName();
    const source = productCard.getAttribute('data-source') || '';

    const isSearch = source === 'search' || document.location.pathname.includes('/search') || productCard.closest('#header-instant-search-container') !== null;

    // Extract price and calculate discount from the wishlist button dataset
    let price = parseFloat(addToCartBtn.getAttribute('data-price') || 0);
    let discount = 0;
    const wishlistBtn = productCard.parentElement ? productCard.parentElement.querySelector('.mswishlistbutton') : null;
    if (wishlistBtn) {
      const wPrice = parseFloat(wishlistBtn.getAttribute('data-price')) || 0;
      const wComparePrice = parseFloat(wishlistBtn.getAttribute('data-compare-at-price')) || 0;
      if (wPrice > 0) price = wPrice;
      if (wComparePrice > wPrice) {
        discount = Number((wComparePrice - wPrice).toFixed(2));
      }
    }

    if (objectID && typeof aa !== 'undefined') {
      const payloadBase = {
        userToken: getAlgoliaUserToken(),
        authenticatedUserToken: getAlgoliaAuthenticatedToken(),
        index: index,
        objectIDs: [objectID],
        value: price,
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AED',
        objectData: [{
          price: price,
          discount: discount,
          quantity: 1
        }]
      };

      if (isSearch && queryID) {
        aa('addedToCartObjectIDsAfterSearch', {
          ...payloadBase,
          eventName: 'addedToCartObjectIDsAfterSearch',
          eventSubtype: 'addToCart',
          queryID: queryID
        });

        const convertedPayloadAfterSearch = { ...payloadBase, eventName: 'convertedObjectIDsAfterSearch', queryID: queryID };
        delete convertedPayloadAfterSearch.objectData;
        delete convertedPayloadAfterSearch.value;
        delete convertedPayloadAfterSearch.currency;
        aa('convertedObjectIDsAfterSearch', convertedPayloadAfterSearch);
      } else {
        const addedPayload = {
          ...payloadBase,
          eventName: 'addedToCartObjectIDs',
          eventSubtype: 'addToCart'
        };
        const convertedPayload = {
          ...payloadBase,
          eventName: 'convertedObjectIDs'
        };
        delete convertedPayload.objectData;
        delete convertedPayload.value;
        delete convertedPayload.currency;

        aa('addedToCartObjectIDs', addedPayload);
        aa('convertedObjectIDs', convertedPayload);
      }
    }
  });

  // Track clicked filters on Algolia instant search
  const processedLabels = new WeakSet();
  document.addEventListener('click', function (e) {
    const label = e.target.closest('.ais-RefinementList-label, .rheostat-handle');
    if (!label || processedLabels.has(label)) return;

    processedLabels.add(label);
    setTimeout(() => processedLabels.delete(label), 500);

    const wrapper = label.closest('.ais-page, .algolia-shopify-instantsearch, #header-instant-search-container') || document;

    let panelGroupName = 'Unknown';
    const panel = label.closest('.filter-drawer__panel, .ais-facet-dropdown-wrapper');

    if (panel) {
      if (panel.classList.contains('filter-drawer__panel')) {
        const panelId = panel.getAttribute('data-panel');
        if (panelId) {
          const categoryBtn = wrapper.querySelector(`.filter-drawer__category[data-target="${panelId}"]`);
          if (categoryBtn) panelGroupName = categoryBtn.innerText.trim();
        }
      } else {
        // For header filters
        const cls = Array.from(panel.classList).find(c =>
          c.startsWith('ais-facet-') && !['ais-facet-dropdown-wrapper', 'ais-facet-disjunctive', 'ais-facet-slider'].includes(c) && !c.includes('--')
        );
        if (cls) {
          panelGroupName = cls.replace('ais-facet-', '');
          panelGroupName = decodeURIComponent(panelGroupName.replace(/\\%/g, '%').replace(/\\\./g, '.'));
        }
      }
    }

    if (label.classList.contains('rheostat-handle')) {
      // Price facet logic: Wait a bit for the handle to settle to get the new range
      setTimeout(() => {
        let clickedFilters = [];
        let priceGroupName = panelGroupName === 'Unknown' ? 'Price' : panelGroupName;

        const lowerHandle = panel ? panel.querySelector('.rheostat-handle-lower') : null;
        const upperHandle = panel ? panel.querySelector('.rheostat-handle-upper') : null;
        let minVal = lowerHandle ? (lowerHandle.getAttribute('aria-valuenow') || lowerHandle.getAttribute('aria-valuemin') || lowerHandle.innerText.trim()) : '';
        let maxVal = upperHandle ? (upperHandle.getAttribute('aria-valuenow') || upperHandle.getAttribute('aria-valuemax') || upperHandle.innerText.trim()) : '';

        if (!minVal && !maxVal && panel) {
          const minInput = panel.querySelector('.ais-RangeInput-input--min, input[name="min"]');
          const maxInput = panel.querySelector('.ais-RangeInput-input--max, input[name="max"]');
          minVal = minInput ? (minInput.value || minInput.placeholder) : '';
          maxVal = maxInput ? (maxInput.value || maxInput.placeholder) : '';
        }

        if (minVal && maxVal && minVal !== 'min' && maxVal !== 'max' && !minVal.includes('min') && !maxVal.includes('max')) {
          clickedFilters.push(`${priceGroupName}:${minVal}-${maxVal}`);
        }

        if (clickedFilters.length > 0 && typeof aa !== 'undefined') {
          aa('clickedFilters', {
            userToken: getAlgoliaUserToken(),
            authenticatedUserToken: getAlgoliaAuthenticatedToken(),
            index: getAlgoliaIndexName(),
            eventName: 'clickedFilters',
            filters: clickedFilters
          });
        }
      }, 800);
      return;
    }

    // For normal facets, wait a moment for Algolia state to update, then extract ALL active filters
    setTimeout(() => {
      let clickedFilters = [];
      try {
        const isHeader = !!label.closest('#header-instant-search-container');
        const helper = isHeader
          ? window.algoliaShopify?.headerInstantSearch?.search?.helper
          : window.algoliaShopify?.instantsearch?.search?.helper;

        if (helper && helper.state) {
          const state = helper.state;
          if (state.disjunctiveFacetsRefinements) {
            Object.keys(state.disjunctiveFacetsRefinements).forEach(key => {
              state.disjunctiveFacetsRefinements[key].forEach(val => clickedFilters.push(`${key}:${val}`));
            });
          }
          if (state.facetsRefinements) {
            Object.keys(state.facetsRefinements).forEach(key => {
              state.facetsRefinements[key].forEach(val => clickedFilters.push(`${key}:${val}`));
            });
          }
          if (state.numericRefinements) {
            Object.keys(state.numericRefinements).forEach(key => {
              let min = '', max = '';
              if (state.numericRefinements[key]['>=']) min = state.numericRefinements[key]['>='][0];
              if (state.numericRefinements[key]['<=']) max = state.numericRefinements[key]['<='][0];
              if (min || max) clickedFilters.push(`${key}:${min}-${max}`);
            });
          }
        }
      } catch (e) { }

      // Fallback if we couldn't get it from the helper
      if (clickedFilters.length === 0) {
        let text = '';
        const labelTextEl = label.querySelector('.ais-RefinementList-labelText, .ais-Menu-label');
        if (labelTextEl) {
          text = labelTextEl.innerText.trim();
        } else {
          const clone = label.cloneNode(true);
          const count = clone.querySelector('.ais-RefinementList-count, .ais-Menu-count');
          if (count) count.remove();
          text = clone.innerText.trim();
        }
        if (text) {
          clickedFilters.push(`${panelGroupName}:${text}`);
        }
      }

      if (clickedFilters.length > 0 && typeof aa !== 'undefined') {
        aa('clickedFilters', {
          userToken: getAlgoliaUserToken(),
          authenticatedUserToken: getAlgoliaAuthenticatedToken(),
          index: getAlgoliaIndexName(),
          eventName: 'clickedFilters',
          filters: clickedFilters
        });
      }
    }, 150);
  });
  // --- END CUSTOM ALGOLIA TRACKING FIXES ---
});

// Prefer Wishlister.refresh for dynamic grids; fall back to script reload only when needed.
window.reloadThirdPartyWishlistApp = function (options = {}) {
  const delay = options && options.immediate ? 0 : 500;

  clearTimeout(window._wishlistReloadTimer);
  window._wishlistReloadTimer = setTimeout(() => {

    if (window.Wishlister && typeof window.Wishlister.refresh === 'function') {
      window.Wishlister.refresh();
      return;
    }

    const oldScript = document.getElementById('binaryic-wishlist-reload');
    if (oldScript) oldScript.remove();

    const script = document.createElement('script');
    script.id = 'binaryic-wishlist-reload';
    // Use Shopify global variables to dynamically assign the shop domain
    script.src = `https://wishlistapp.binaryic.in/js/app.js?shop=${window.Shopify?.shop || 'watches-ae.myshopify.com'}`;
    script.defer = true;
    document.body.appendChild(script);
  }, delay);

};


// 

(function () {
  function checkEmailTakenError() {
    var errors = document.querySelectorAll(
      '.cf-form-actions .cf-step-invalid .cf-form-errors li'
    );

    var found = false;

    errors.forEach(function (li) {
      var message = li.textContent.trim();

      if (message === 'Email is already taken') {
        found = true;

        var formActions = li.closest('.cf-form-actions');

        if (formActions) {
          formActions.classList.add('active');
        }
      }
    });

    return found;
  }

  // Check immediately
  checkEmailTakenError();

  // Watch for Customer Fields error being added dynamically
  var observer = new MutationObserver(function () {
    checkEmailTakenError();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();